<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="EPIGRAPH">The Lord said, “I have heard the cry of my people.”</p>
<p class="EPICREDIT _idGenParaOverride-1">adapted from Exodus 3:7</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wolterstorff_The_God_We_Worship_text_CC.vue?59025a18